import updateGAEventLocation from '../updateGAEventLocation';
import get from 'lodash/get';
import employeeRoleCheck from '../../../permissions/EmployeeRoleCheck';
import getGlobalState from '../../../selectors/getGlobalState';

let propertyMap = {};

const unregisterProperties = () => {
  // store the GA properties to persist across login sessions
  let deviceId;
  if (propertyMap['device_id']) {
    deviceId = propertyMap['device_id'];
  }
  let handset;
  if (propertyMap['handset']) {
    handset = propertyMap['handset'];
  }

  // clear all GA properties
  propertyMap = {};

  // restore the GA propeties
  if (deviceId) {
    propertyMap['device_id'] = deviceId;
  }
  if (handset) {
    propertyMap['handset'] = handset;
  }
};

const loadGA = () => {
  (function (s, o, g, a, m) {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
    (a = s.createElement(o)), // eslint-disable-line
      (m = s.getElementsByTagName(o)[0]); // eslint-disable-line
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
  })(document, 'script', 'https://www.googletagmanager.com/gtag/js');
};

const initialize = (trackingIdUA, trackingIdGA4) => {
  loadGA();

  window.gtag('js', new Date());
  window.gtag('config', trackingIdGA4);
};

const set = fieldsObject => {
  window.gtag('set', fieldsObject);
};
const setDimension = ({ key, value }) => {
  const obj = {};
  obj[key] = value;
  window.gtag('set', obj);
};

const setUserId = userId => {
  propertyMap = { ...propertyMap, user_id: userId };
};

const registerProperties = propertyObject => {
  propertyMap = { ...propertyMap, ...propertyObject };
};

const setLogCampaignDetails = propertyObject => {};

// @otherParams is a object of key:value pair
const pageview = ({ path = '', title = '', location = '', otherParams = {} }) => {
  path = path.replace(/\/\d+/g, ''); // To remove ID from URL before loging in GA
  window.gtag('event', 'page_view', {
    page_title: title,
    page_path: path,
    location: location,
    ...otherParams,
    ...propertyMap
  });
};
// @otherParams is a object of key:value pair
const event = ({ category = '', action, otherParams = {} }) => {
  if (!action) {
    console.error('args.action is required in event()');
    return;
  }

  const state = getGlobalState();
  const isUserEmployee = employeeRoleCheck(state);
  const locationMandatoryGAEventMap = get(
    state,
    'loginReducer.dashboard.featureFlag.location_data_config.gaEventName',
    {}
  );
  if (isUserEmployee && locationMandatoryGAEventMap[action]) {
    updateGAEventLocation(action)
      .then(position => {
        const latitudeAndLongitude = position;
        window.gtag('event', action, {
          event_category: category,
          ...otherParams,
          ...propertyMap,
          ...latitudeAndLongitude
        });
      })
      .catch(() => {
        window.gtag('event', action, {
          event_category: category,
          ...otherParams,
          ...propertyMap
        });
      });
  } else {
    window.gtag('event', action, {
      event_category: category,
      ...otherParams,
      ...propertyMap
    });
  }
};
// @otherParams is a object of  key:value pair
const timings = ({ category = '', otherParams = {} }) => {
  window.gtag('event', 'timing_complete', {
    event_category: category,
    ...otherParams,
    ...propertyMap
  });
};
const exception = ({ message = '', fatal = false }) => {
  window.gtag('event', 'exception', {
    description: message,
    fatal: fatal,
    ...propertyMap
  });
};
export default {
  initialize,
  set,
  setDimension,
  setUserId,
  registerProperties,
  unregisterProperties,
  pageview,
  event,
  exception,
  timings,
  setLogCampaignDetails
};
